import {
  MONTHREPORTLIST,
} from 'actions/monthreport';
import {reducerPackage} from "../../utils";

export const monthreportList = reducerPackage(MONTHREPORTLIST);
